import { Paper, Stack } from '@mui/material'
import React from 'react'
import { OrderSteps } from '../schedule-order/OrderSteps'

export const ActiveOrders = () => {
  return (
    <Stack spacing={2} sx={{ padding: 1 }}>
      <Paper sx={{padding: 1,}}>
        <OrderSteps />
      </Paper>
      <Paper sx={{padding: 1,}}>
        <OrderSteps />
      </Paper>
      <Paper sx={{padding: 1,}}>
        <OrderSteps active/>
      </Paper>
    </Stack>
  )
}
